import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { getSettings } from './utils/routes';

/**
 * React Query hook for fetching content settings.
 * @returns The result of the query
 */
export const useContentSettings = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["contentSettings"],
      queryFn: _temp,
      refetchOnWindowFocus: false,
      staleTime: Infinity
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};
function _temp() {
  return getSettings();
}